export const stringArrayMatch = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((i) => b.includes(i));
